import { Store } from '@ngrx/store';
import { TrInputComponent } from './../tr-input/tr-input.component';
import { Component, ElementRef, Renderer2, ViewChild, OnInit } from '@angular/core';
import { AppState } from '../../../interfaces/app-state.interface';

@Component({
    selector: "tr-email",
    templateUrl: "./tr-email.component.html",
    styleUrls: ["./tr-email.component.scss"],
})
export class TrEmailComponent extends TrInputComponent implements OnInit {
    @ViewChild("formInput", { static: true }) public formInput: ElementRef;

    constructor(private render: Renderer2, store: Store<AppState>) {
        super(store);
    }

    public ngOnInit() {
        super.ngOnInit();
    }
}
